<template class="mobile">
  <mdb-container fluid class="">
    <!-- Menu: Actions -->
    <!--
    <section v-if="loggedIn === true" class="fixed-top z-depth-2 p-0 d-none">
      <mdb-tab header justify color="gww-blue" class="mx-0 mb-0 gww-tabs">
        <mdb-tab-item icon="home" :active="activeTab == 0" @click.native.prevent="activeTab = 0"></mdb-tab-item>
        <mdb-tab-item icon="user" :active="activeTab == 1" @click.native.prevent="activeTab = 1"></mdb-tab-item>
        <mdb-tab-item icon="history" fas :active="activeTab == 2" @click.native.prevent="activeTab = 2"></mdb-tab-item>
        <mdb-tab-item icon="edit" far :active="activeTab == 3" @click.native.prevent="activeTab = 3"></mdb-tab-item>
      </mdb-tab>
    </section>
    -->
    <!-- /Menu: Actions -->
    <!-- Section: Login -->
    <section v-if="loggedIn != true" class="pt-4 pt-sm-5 mb-4 mb-lg-5">
      <mdb-row>
        <mdb-col></mdb-col>
        <mdb-col lg="6" xl="5">
          <mdb-card>
            <div class="header pt-3 gww-blue">
              <mdb-row class="d-flex justify-content-center pt-3 pb-3">
                <h4 class="white-text font-weight-bold">Leadforge Mobile <small>iOS</small></h4>
              </mdb-row>
            </div>
            <mdb-card-body class="mx-4 mt-4">
              <mdb-input type="text" size="lg" outline label="Benutzername" v-model="username"/>
              <mdb-input type="password" size="lg" outline label="API-Key" v-model="password"/>
              <span class="text-danger">{{ loginError }}</span>
              <mdb-btn block size="lg" color="gww-blue" class="mt-5 ml-0" @click.native="login">
                <h4 class="text-capitalize m-0">
                  <mdb-icon icon="sign-in-alt" class=""/>
                  Login
                </h4>
              </mdb-btn>
              <!--<mdb-collapse
                :toggleTag="['a', 'button']"
                :togglers="1"
                :toggleClass="['mt-5 ml-0 btn btn-gww-grey btn-lg btn-block ripple-parent']"
                :toggleText="['Als App auf dem Homescreen installieren']"
              >
                <h5 class="mt-4">Anleitung für Safari (iOS)</h5>
                <ol class="pb-3 pl-4">
                  <li>Tippen Sie unten auf teilen <img class="pb-2" src="static/icons/safari-share.png"> um das Menü des Browsers zu öffnen</li>
                  <li>Tippen Sie auf "Zum Home-Bildschirm"</li>
                  <li>Tippen Sie auf "Hinzufügen"</li>
                  <li>Leadforge Mobile befindet sich ab jetzt auf Ihrem Homescreen</li>
                </ol>
              </mdb-collapse>-->
              <p class="mt-4 mb-1 small text-center grey-text w-100">Version 4.1</p>
            </mdb-card-body>
          </mdb-card>
        </mdb-col>
        <mdb-col></mdb-col>
      </mdb-row>
    </section>
    <!-- /Section: Login -->
    <!-- Section: Main -->
    <section v-if="loggedIn === true" class="mt-0 pt-0 mb-4 gww-bottom-margin">
      <!-- Section: Home -->
      <section v-show="activeTab == 0">
        <mdb-btn block color="gww-blue" class="mt-3 mb-3 ml-0" @click.native="activeTab = 1">
          <h2 class="mt-1 mb-2">
            <mdb-icon icon="plus" class=""/>
          </h2>
          <h4 class="text-capitalize display-5">Neue Anfrage</h4>
        </mdb-btn>
        <mdb-btn block color="gww-blue" class="mt-3 mb-3 ml-0" @click.native="activeTab = 2">
          <h2 class="mt-1 mb-2">
            <mdb-icon icon="redo" class=""/>
          </h2>
          <h4 class="text-capitalize display-5">Anfrage laden</h4>
        </mdb-btn>
        <mdb-btn block color="grey" class="mt-3 mb-3 ml-0" @click.native="showSettings = true">
          <h2 class="mt-1 mb-2">
            <mdb-icon icon="cog" class=""/>
          </h2>
          <h4 class="text-capitalize display-5">Einstellungen</h4>
        </mdb-btn>
        <mdb-card class="mt-4" v-show="eventLabel !== ''">
          <mdb-card-body>
            <h5 class="dark-grey-text text-center mb-0">{{ eventLabel }}</h5>
          </mdb-card-body>
          <mdb-card-footer class="pt-0 pb-0 dark-grey-text">
            <mdb-row>
              <mdb-col class="pt-3 pr-4 pb-1 pl-4 text-center border-right">
                <h3>
                  <mdb-icon icon="user-tie" class=""/>
                  <br>
                  {{ eventTotalTraders }}
                </h3>
              </mdb-col>
              <mdb-col class="pt-3 pr-4 pb-1 pl-4 text-center border-right">
                <h3>
                  <mdb-icon icon="user" class=""/>
                  <br>
                  {{ eventTotalClients }}
                </h3>
              </mdb-col>
              <mdb-col class="pt-3 pr-4 pb-1 pl-4 text-center">
                <h3>
                  <mdb-icon icon="file-invoice" class=""/>
                  <br>
                  {{ eventTotalRequests }}
                </h3>
              </mdb-col>
            </mdb-row>
          </mdb-card-footer>
        </mdb-card>
      </section>
      <!-- /Section: Home -->
      <!-- Section: Select Client -->
      <section class="bg-white" v-show="activeTab == 1">
        <mdb-row>
          <mdb-col col="10">
            <h3 class="mt-3 grey-text">Besucher-ID eingeben</h3>
          </mdb-col>
          <mdb-col col="2">
            <!--<mdb-btn size="sm" color="" class="float-right mt-2 pl-2 pr-2" v-on:click="toggleCamera = !toggleCamera"><mdb-icon icon="barcode" size="3x" /></mdb-btn>-->
          </mdb-col>
        </mdb-row>
        <barcode-scanner
          v-show="toggleScanner"
          class="barcode-scanner"
          :source="camera"
          @bcs-scanned="onDecode"
        >
        </barcode-scanner>
        <video
          class="cameraView"
          ref="cameraView"
          crossorigin="anonymous"
          muted
          autoplay
          playsinline
          controls
          controlslist="nodownload nofullscreen"
        >
        </video>
        <mdb-input id="search-client-input" outline size="lg" type="tel" inputmode="numeric" pattern="[0-9]*" autocomplete="off" label="ID" color="blue" class="mt-3 mb-0 gww-blue-text gww-blue-border" v-model="query" @keyup.native="searchClient()"/>
        <div class="panel-footer pr-5" v-if="search_data.length">
          <ul class="client-search list-group position-absolute w-100 shadow">
            <a href="#" class="list-group-item" v-for="client in search_data" v-bind:key="client.id" @click="getClientData(client)">{{ client.id - 0 }}</a>
          </ul>
        </div>
        <mdb-card class="mt-4" v-show="clientName != '-'">
          <mdb-card-body>
            <p class="small mb-0">{{ clientCompany }}</p>
            <h2 class="mb-0">{{ clientName }}</h2>
          </mdb-card-body>
          <mdb-card-footer color="gww-blue" class="grey-text">
            eingeladen von {{ traderCompany }}
          </mdb-card-footer>
        </mdb-card>
      </section>
      <!-- /Section: Select Client -->
      <!-- Section: History -->
      <section class="bg-white" v-show="activeTab == 2">
        <h3 class="mt-3 grey-text">Anfrage laden</h3>
        <mdb-datatable
          id="requests-table"
          ref="requestsTable"
          :data="'https://ios.gww-lf.de/api/list_requests.php?account=' + username"
          :tfoot="false"
          :sorting="false"
          focus
          arrows
          searchPlaceholder="Suche"
          :searching="true"
          refresh
          showingText="Zeige"
          class="product-data"
          @selectRow="selectQuotation"
          :pagination="false"
        />
      </section>
      <!-- /Section: History -->
      <!-- Section: Configure Request -->
      <section class="bg-white" v-show="activeTab == 3">
        <h3 class="mt-3 grey-text">Anfrage konfigurieren</h3>
        <mdb-card class="mt-3" v-show="clientName != '-'">
          <mdb-card-body class="pt-2 pb-2">
            <p class="small mb-0 dark-grey-text">{{ clientCompany }}</p>
            <h5 class="mb-0 dark-grey-text">{{ clientName }}</h5>
          </mdb-card-body>
          <mdb-card-footer class="pt-2 pb-2 grey-text">
            eingeladen von {{ traderCompany }}
          </mdb-card-footer>
        </mdb-card>
        <h5 class="mt-4">Angebotstyp</h5>
        <mdb-btn-group class="w-100">
          <mdb-btn block size="lg" color="gww-blue" @click.native="toggleQuotationMode1" :active="activeQuotationMode1" class="gww-button p-4 ml-0 text">
            <h5 class="text-capitalize display-5 mb-0 font-weight-normal">Infogespräch</h5>
          </mdb-btn>
          <mdb-btn block size="lg" color="gww-blue" @click.native="toggleQuotationMode2" :active="activeQuotationMode2" class="gww-button p-4">
            <h5 class="text-capitalize display-5 mb-0 font-weight-normal">Artikel</h5>
          </mdb-btn>
        </mdb-btn-group>
        <hr class="mt-4">
        <h6 class="mt-4">Katalog</h6>
        <mdb-btn-group class="w-100">
          <mdb-btn block size="lg" color="gww-blue" @click.native="toggleCatalogStatus1" :active="activeCatalogStatus1" class="gww-button p-3 ml-0">
            <h6 class="text-capitalize mb-0">Nein</h6>
          </mdb-btn>
          <mdb-btn block size="lg" color="gww-blue" @click.native="toggleCatalogStatus2" :active="activeCatalogStatus2" class="gww-button p-3">
            <h6 class="text-capitalize mb-0">Erhalten</h6>
          </mdb-btn>
          <mdb-btn block size="lg" color="gww-blue" @click.native="toggleCatalogStatus3" :active="activeCatalogStatus3" class="gww-button p-3">
            <h6 class="text-capitalize mb-0">Zusenden</h6>
          </mdb-btn>
        </mdb-btn-group>
        <h6 class="mt-4">Notizen</h6>
        <div class="input-group" v-show="noteTab == 0">
          <div class="input-group-prepend">
            <span class="input-group-text" id="basic-addon">
              <i class="fas fa-pencil-alt prefix"></i>
            </span>
          </div>
          <textarea class="form-control" rows="2" v-model="notePublic"></textarea>
        </div>
        <div class="input-group" v-show="noteTab == 1">
          <div class="input-group-prepend">
            <span class="input-group-text" id="basic-addon">
              <i class="fas fa-pencil-alt prefix"></i>
            </span>
          </div>
          <textarea class="form-control" rows="2" v-model="notePrivate"></textarea>
        </div>
        <mdb-btn-group class="w-100">
          <mdb-btn block size="lg" color="gww-blue" @click.native.prevent="noteTab = 0" :active="noteTab == 0" class="gww-button p-3 ml-0">
            <h6 class="text-capitalize mb-0">Notiz Händler</h6>
          </mdb-btn>
          <mdb-btn block size="lg" color="gww-blue" @click.native.prevent="noteTab = 1" :active="noteTab == 1" class="gww-button p-3">
            <h6 class="text-capitalize mb-0">Notiz intern</h6>
          </mdb-btn>
        </mdb-btn-group>
      </section>
      <!-- /Section: Configure Request -->
      <!-- Section: Select Product -->
      <section class="bg-white" v-show="activeTab == 4">
        <h3 class="mt-3 grey-text">Artikel auswählen</h3>
        <mdb-datatable
          id="products-table"
          ref="productsTable"
          :data="'https://ios.gww-lf.de/api/list_products.php?account=' + username"
          :tfoot="false"
          :sorting="false"
          focus
          arrows
          searchPlaceholder="Suche"
          :searching="true"
          refresh
          showingText="Zeige"
          class="product-data"
          @selectRow="selectProduct"
          :pagination="false"
        />
      </section>
      <!-- /Section: Select Product -->
      <!-- Section: Configure Product -->
      <section class="bg-white" v-show="activeTab == 5">
        <h3 class="mt-3 grey-text">Artikel konfigurieren</h3>
        <mdb-card class="mt-3">
          <mdb-card-body class="pt-2 pb-2">
            <mdb-row>
              <mdb-col col="10" class="d-flex align-items-center">
                <h5 class="mb-0 dark-grey-text">{{ productLabel }}</h5>
              </mdb-col>
              <mdb-col col="2">
                <mdb-btn flat size="sm" class="float-right p-2 gww-blue-text" @click.native="activeTab = 4"><mdb-icon icon="edit" size="2x" /></mdb-btn>
              </mdb-col>
            </mdb-row>
          </mdb-card-body>
          <mdb-card-footer class="pt-2 pb-2 grey-text" v-if="productId != 0">
            Art.-Nr.: {{ productItemNumber }}<span v-if="productVariant != '' && productVariant != '-'">-{{ productVariant }}</span>
          </mdb-card-footer>
        </mdb-card>
        <hr class="mt-4">
        <h5 class="mt-4">Notizen</h5>
        <div class="input-group" v-show="noteTab == 0">
          <div class="input-group-prepend">
            <span class="input-group-text" id="basic-addon">
              <i class="fas fa-pencil-alt prefix"></i>
            </span>
          </div>
          <textarea class="form-control" rows="2" v-model="notePublic"></textarea>
        </div>
        <div class="input-group" v-show="noteTab == 1">
          <div class="input-group-prepend">
            <span class="input-group-text" id="basic-addon">
              <i class="fas fa-pencil-alt prefix"></i>
            </span>
          </div>
          <textarea class="form-control" rows="2" v-model="notePrivate"></textarea>
        </div>
        <mdb-btn-group class="w-100">
          <mdb-btn block size="lg" color="gww-blue" @click.native.prevent="noteTab = 0" :active="noteTab == 0" class="gww-button p-3 ml-0">
            <h6 class="text-capitalize mb-0">Notiz Händler</h6>
          </mdb-btn>
          <mdb-btn block size="lg" color="gww-blue" @click.native.prevent="noteTab = 1" :active="noteTab == 1" class="gww-button p-3">
            <h6 class="text-capitalize mb-0">Notiz intern</h6>
          </mdb-btn>
        </mdb-btn-group>
        <hr class="mt-4">
        <h5 class="mt-4">Muster</h5>
        <mdb-btn-group class="w-100">
          <mdb-btn size="lg" color="gww-blue" @click.native="toggleSampleStatus1" :active="activeSampleStatus1" class="gww-button p-3 ml-0">
            <h6 class="text-capitalize mb-0">&nbsp;&nbsp;Nein&nbsp;&nbsp;</h6>
          </mdb-btn>
          <mdb-btn size="lg" color="gww-blue" @click.native="toggleSampleStatus2" :active="activeSampleStatus2" class="gww-button p-3">
            <h6 class="text-capitalize mb-0">Erhalten</h6>
          </mdb-btn>
        </mdb-btn-group>
        <mdb-btn-group class="w-100">
          <mdb-btn size="lg" color="gww-blue" @click.native="toggleSampleStatus3" :active="activeSampleStatus3" class="gww-button p-3 ml-0">
            <h6 class="text-capitalize mb-0">Mit Berechnung</h6>
          </mdb-btn>
          <mdb-btn size="lg" color="gww-blue" @click.native="toggleSampleStatus4" :active="activeSampleStatus4" class="gww-button p-3">
            <h6 class="text-capitalize mb-0">Ohne Berechnung</h6>
          </mdb-btn>
        </mdb-btn-group>
        <hr class="mt-4">
        <h5 class="mt-4">Katalog</h5>
        <mdb-btn-group class="w-100">
          <mdb-btn block size="lg" color="gww-blue" @click.native="toggleCatalogStatus1" :active="activeCatalogStatus1" class="gww-button p-3 ml-0">
            <h6 class="text-capitalize mb-0">Nein</h6>
          </mdb-btn>
          <mdb-btn block size="lg" color="gww-blue" @click.native="toggleCatalogStatus2" :active="activeCatalogStatus2" class="gww-button p-3">
            <h6 class="text-capitalize mb-0">Erhalten</h6>
          </mdb-btn>
          <mdb-btn block size="lg" color="gww-blue" @click.native="toggleCatalogStatus3" :active="activeCatalogStatus3" class="gww-button p-3">
            <h6 class="text-capitalize mb-0">Zusenden</h6>
          </mdb-btn>
        </mdb-btn-group>
        <hr class="mt-4">
        <h5 class="mt-4">Werbeanbringungen</h5>
        <mdb-select
          outline
          multiple
          search
          icon="edit"
          far
          iconClass="gww-blue-text"
          searchPlaceholder="Suche"
          limitPlaceholder="Optionen ausgewählt"
          resultText="Nichts gefunden!"
          class="mt-0"
          :options="finishingOptions"
        />
        <hr class="mt-4">
        <mdb-row class="mb-3">
          <mdb-col col="6" class="d-flex align-items-center">
            <h5 class="m-0">Preisstaffeln</h5>
          </mdb-col>
          <mdb-col col="6">
            <mdb-dropdown class="float-right">
              <mdb-dropdown-toggle color="white" slot="toggle">
                <h6 class="d-inline text-capitalize mb-0">Vorlagen</h6>
              </mdb-dropdown-toggle>
              <mdb-dropdown-menu right>
                <mdb-dropdown-item @click.prevent="loadPriceTablePreset(1)">Eine Staffelmenge</mdb-dropdown-item>
                <mdb-dropdown-item @click.prevent="loadPriceTablePreset(2)">Drei Staffelmengen</mdb-dropdown-item>
                <mdb-dropdown-item @click.prevent="loadPriceTablePreset(3)">Alle Staffelmengen</mdb-dropdown-item>
                <mdb-dropdown-item @click.prevent="loadPriceTablePreset(4)">Eine Staffelmenge mit Menge 1</mdb-dropdown-item>
              </mdb-dropdown-menu>
            </mdb-dropdown>
          </mdb-col>
        </mdb-row>
        <span @click="addToPriceTable" class="table-add float-left mb-3 mr-2"><a href="#!" class="text-success"><mdb-icon icon="plus" class="fa-2x"/></a></span>
        <mdb-table-editable
          :columns="editableColumns"
          :rows="editableRows"
          ref="priceTable"
          fixed
          :sorting="false"
          class="price-data mb-5"
          @click.native="tweakTable($event)"
          @hook:updated="translateTable"
        />
      </section>
    </section>
    <!-- /Section: History -->
    <FlashMessage></FlashMessage>
    <!-- Footer: Actions -->
    <mdb-footer v-if="loggedIn === true" color="gww-grey" class="fixed-bottom z-depth-2 border-top p-2">
      <mdb-btn size="lg" color="white" class="float-right p-3" @click.native="showLogout = true" v-show="activeTab === 0">
        <h5 class="d-inline text-capitalize dark-grey-text">
          <mdb-icon icon="sign-out-alt" class="mr-1" />
          Logout
        </h5>
      </mdb-btn>
      <mdb-btn size="lg" color="white" class="float-right p-3" @click.native="activeTab = 3" :disabled="clientName === '-'" v-show="activeTab === 1">
        <h5 class="d-inline text-capitalize gww-blue-text">
          Weiter
          <mdb-icon icon="chevron-right" class="ml-1" />
        </h5>
      </mdb-btn>
      <mdb-btn size="lg" color="white" class="float-right p-3" @click.native="loadQuotation()" :disabled="selectId === 0" v-show="activeTab === 2">
        <h5 class="d-inline text-capitalize gww-blue-text">
          <mdb-icon icon="redo" class="mr-1" />
          Laden
        </h5>
      </mdb-btn>
      <mdb-btn size="lg" color="white" class="float-right p-3" @click.native="loadProduct()" :disabled="selectId === 0" v-show="activeTab === 4">
        <h5 class="d-inline text-capitalize gww-blue-text">
          Auswählen
          <mdb-icon icon="chevron-right " class="mr-1" />
        </h5>
      </mdb-btn>
      <mdb-btn size="lg" color="white" class="float-left p-3" @click.native="cancelProduct()" v-show="activeTab === 4">
        <h5 class="d-inline text-capitalize dark-grey-text">
          <mdb-icon icon="chevron-left" class="mr-1" />
          Zurück
        </h5>
      </mdb-btn>
      <mdb-btn size="lg" color="green" class="float-right p-3" @click.native="showSave = true" v-show="activeTab === 3 || activeTab === 5">
        <h5 class="d-inline text-capitalize">
          <mdb-icon icon="cloud-upload-alt" />
          Speichern
        </h5>
      </mdb-btn>
      <mdb-btn size="lg" color="red" class="float-left p-3" @click.native="showDelete = true" v-show="activeTab === 3 || activeTab === 5">
        <h5 class="d-inline text-capitalize">
          <mdb-icon icon="times" class="ml-1" />
          Verwerfen
        </h5>
      </mdb-btn>
      <mdb-btn size="lg" color="white" class="float-left p-3" @click.native="resetQuotation(true)" v-show="activeTab === 1 || activeTab === 2">
        <h5 class="d-inline text-capitalize red-text">
          <mdb-icon icon="times" class="mr-1" />
          Abbrechen
        </h5>
      </mdb-btn>
    </mdb-footer>
    <!-- /Footer: Actions -->
    <!-- Modal: Logout -->
    <mdb-modal
      side
      size="sm"
      position="bottom-right"
      direction="bottom"
      :show="showLogout"
      @close="showLogout = false"
    >
      <mdb-modal-header :close="false" color="red">
        <mdb-modal-title>Logout</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body>
        <mdb-row>
          <mdb-col col="3">
            <mdb-icon icon="sign-out-alt" size="4x" class="red-text"/>
          </mdb-col>
          <mdb-col col="9" class="d-flex align-items-center">
            <h5 class="m-0">Wollen Sie sich wirklich ausloggen?</h5>
          </mdb-col>
        </mdb-row>
      </mdb-modal-body>
      <mdb-modal-footer>
        <mdb-btn size="lg" color="white" class="float-right p-3" @click="showLogout = false">
          <h5 class="d-inline text-capitalize dark-grey-text">
            <mdb-icon icon="times" class="mr-1" />
            Abbrechen
          </h5>
        </mdb-btn>
        <mdb-btn size="lg" color="red" class="float-right p-3" @click.native="logout">
          <h5 class="d-inline text-capitalize">
            <mdb-icon icon="sign-out-alt" class="mr-1" />
            Logout
          </h5>
        </mdb-btn>
      </mdb-modal-footer>
    </mdb-modal>
    <!-- /Modal: Logout -->
    <!-- Modal: Settings -->
    <mdb-modal
      size="lg"
      direction="bottom"
      :show="showSettings"
      @close="showSettings = false"
    >
      <mdb-modal-header :close="false" color="gww-blue">
        <mdb-modal-title>Einstellungen</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body>
        <mdb-row>
          <mdb-col col="12">
            <h5 class="mb-3"><mdb-icon icon="user" far class="mr-1 gww-blue-text" /> Außendienst</h5>
            <mdb-input outline size="lg" color="blue" class="gww-blue-text gww-blue-border mt-0" autocomplete="off" label="Ihr Vor- und Nachname" v-model="associate" />
            <hr>
          </mdb-col>
        </mdb-row>
        <mdb-row>
          <mdb-col col="12">
            <h5><mdb-icon icon="calendar" far class="mr-1 gww-blue-text" /> Veranstaltung</h5>
            <mdb-select outline label="Veranstaltungsreihe" v-model="this.eventCategoryOptions" @getValue="getEventCategories" />
            <mdb-select outline label="Jahr" v-model="this.eventYearOptions" @getValue="getEventYears" />
            <mdb-select outline label="Termin" v-model="this.eventLocationOptions" @getValue="setEventLocation" />
          </mdb-col>
        </mdb-row>
      </mdb-modal-body>
      <mdb-modal-footer>
        <mdb-btn size="lg" color="white" class="float-right p-3" @click="showSettings = false">
          <h5 class="d-inline text-capitalize dark-grey-text">
            <mdb-icon icon="chevron-down" class="mr-1" />
            Schließen
          </h5>
        </mdb-btn>
      </mdb-modal-footer>
    </mdb-modal>
    <!-- /Modal: Settings -->
    <!-- Modal: Save -->
    <mdb-modal
      side
      size="sm"
      position="bottom-right"
      direction="bottom"
      :show="showSave"
      @close="showSave = false"
    >
      <mdb-modal-header :close="false" color="green">
        <mdb-modal-title>Anfrage speichern</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body>
        <mdb-row class="mb-3">
          <mdb-col col="3" class="d-flex align-items-center">
            <mdb-icon icon="cloud-upload-alt" size="4x" class="green-text"/>
          </mdb-col>
          <mdb-col col="9" class="d-flex align-items-center">
              <h5 class="m-0">Wollen Sie die aktuelle Anfrage speichern?</h5>
          </mdb-col>
        </mdb-row>
        <mdb-row>
          <mdb-col>
            <p>Im Anschluß wird ein leeres Angebot erstellt und Sie können mit dem bestehenden Kunden fortfahren oder einen neuen auswählen.</p>
          </mdb-col>
        </mdb-row>
      </mdb-modal-body>
      <mdb-modal-footer center>
        <mdb-row class="w-100">
          <mdb-col>
            <mdb-btn block size="lg" color="white" @click="showSave = false" class="p-4">
              <h5 class="text-capitalize display-5 mb-0 dark-grey-text">Abbrechen</h5>
            </mdb-btn>
          </mdb-col>
        </mdb-row>
        <mdb-row class="w-100">
          <mdb-col>
            <mdb-btn block size="lg" color="green" @click.native="saveQuotation(true, false)" class="p-4">
              <h5 class="text-capitalize display-5 mb-0">Weitere Anfrage</h5>
            </mdb-btn>
          </mdb-col>
        </mdb-row>
        <mdb-row class="w-100">
          <mdb-col>
            <mdb-btn block size="lg" color="green" @click.native="saveQuotation(true, true)" class="p-4">
              <h5 class="text-capitalize display-5 mb-0">Neuer Kunde</h5>
            </mdb-btn>
          </mdb-col>
        </mdb-row>
      </mdb-modal-footer>
    </mdb-modal>
    <!-- /Modal: Save -->
    <!-- Modal: Delete -->
    <mdb-modal
      side
      size="sm"
      position="bottom-right"
      direction="bottom"
      :show="showDelete"
      @close="showDelete = false"
    >
      <mdb-modal-header :close="false" color="red">
        <mdb-modal-title>Anfrage verwerfen</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body>
        <mdb-row class="mb-3">
          <mdb-col col="3" class="d-flex align-items-center">
            <mdb-icon icon="times" size="4x" class="red-text"/>
          </mdb-col>
          <mdb-col col="9" class="d-flex align-items-center">
              <h5 class="m-0">Wollen Sie die aktuelle Anfrage wirklich verwerfen?</h5>
          </mdb-col>
        </mdb-row>
        <mdb-row>
          <mdb-col>
            <p>Im Anschluß wird ein leeres Angebot erstellt und Sie können mit dem bestehenden Kunden fortfahren oder einen neuen auswählen.</p>
          </mdb-col>
        </mdb-row>
      </mdb-modal-body>
      <mdb-modal-footer center>
        <mdb-row class="w-100">
          <mdb-col>
            <mdb-btn block size="lg" color="white" @click="showDelete = false" class="p-4">
              <h5 class="text-capitalize display-5 mb-0 dark-grey-text">Abbrechen</h5>
            </mdb-btn>
          </mdb-col>
        </mdb-row>
        <mdb-row class="w-100">
          <mdb-col>
            <mdb-btn block size="lg" color="red" @click.native="resetQuotation(false)" class="p-4">
              <h5 class="text-capitalize display-5 mb-0">Weitere Anfrage</h5>
            </mdb-btn>
          </mdb-col>
        </mdb-row>
        <mdb-row class="w-100">
          <mdb-col>
            <mdb-btn block size="lg" color="red" @click.native="resetQuotation(true)" class="p-4">
              <h5 class="text-capitalize display-5 mb-0">Neuer Kunde</h5>
            </mdb-btn>
          </mdb-col>
        </mdb-row>
      </mdb-modal-footer>
    </mdb-modal>
    <!-- /Modal: Delete -->
    <!-- Modal: Clone -->
    <mdb-modal :show="showClone" @close="showClone = false">
      <mdb-modal-header>
        <mdb-modal-title>Angebot duplizieren</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body>
        <mdb-row>
          <mdb-col col="3" class="mb-3">
            <mdb-icon icon="clone" size="4x" class="gww-grey-text"/>
          </mdb-col>
          <mdb-col col="9" class="mb-2">
            <p class="mb-4">
              <strong>Wollen Sie das gewählte Angebot als Vorlage verwenden?</strong>
            </p>
            <p>
              Im Anschluß wird ein neues Angebot erstellt und mit den Daten der Vorlage befüllt.
            </p>
          </mdb-col>
        </mdb-row>
      </mdb-modal-body>
      <mdb-modal-footer center>
        <mdb-btn outline="gww-blue" @click="showClone = false">Abbrechen</mdb-btn>
        <mdb-btn color="gww-blue">Duplizieren</mdb-btn>
      </mdb-modal-footer>
    </mdb-modal>
    <!-- /Modal: Clone -->
  </mdb-container>
</template>

<script>
import { mdbContainer, mdbRow, mdbCol, mdbBadge, mdbIcon, mdbBtn, mdbBtnGroup, mdbModal, mdbModalHeader, mdbModalTitle, mdbModalBody, mdbModalFooter, mdbInput, mdbSelect, mdbCard, mdbCardBody, mdbCardFooter, mdbCardHeader, mdbCardText, mdbCardTitle, mdbNavbar, mdbNavbarBrand, mdbNavbarToggler, mdbNavbarNav, mdbFormInline, mdbNavItem, mdbDropdown, mdbDropdownToggle, mdbDropdownItem, mdbDropdownMenu, mdbTbl, mdbTblHead, mdbTblBody, mdbTab, mdbTabs, mdbTabItem, mdbView, mdbDatatable, mdbListGroup, mdbListGroupItem, mdbTooltip, mdbTableEditable, mdbFooter, mdbCollapse } from 'mdbvue'
import axios from 'axios'
import BarcodeScanner from '@undecaf/vue-barcode-scanner'

window.axios = axios
axios.defaults.baseURL = 'https://ios.gww-lf.de/api/'

export default {
  name: 'Quotation',
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbBadge,
    mdbIcon,
    mdbBtn,
    mdbBtnGroup,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbInput,
    mdbSelect,
    mdbCard,
    mdbCardBody,
    mdbCardFooter,
    mdbCardHeader,
    mdbCardText,
    mdbCardTitle,
    mdbNavbar,
    mdbNavbarBrand,
    mdbNavbarToggler,
    mdbNavbarNav,
    mdbFormInline,
    mdbNavItem,
    mdbDropdown,
    mdbDropdownToggle,
    mdbDropdownItem,
    mdbDropdownMenu,
    mdbTbl,
    mdbTblHead,
    mdbTblBody,
    mdbTab,
    mdbTabs,
    mdbTabItem,
    mdbView,
    mdbDatatable,
    mdbListGroup,
    mdbListGroupItem,
    mdbTooltip,
    mdbTableEditable,
    mdbFooter,
    mdbCollapse,
    BarcodeScanner
  },
  data () {
    return {
      showLogout: false,
      showSettings: false,
      showDelete: false,
      showSave: false,
      showClone: false,
      // productData: productData,
      // priceData: priceData,
      toggleCamera: false,
      toggleScanner: false,
      activeTab: -1,
      noteTab: 0,
      keepClient: false,
      activeQuotationMode1: true,
      activeQuotationMode2: false,
      activeCatalogStatus1: true,
      activeCatalogStatus2: false,
      activeCatalogStatus3: false,
      activeSampleStatus1: true,
      activeSampleStatus2: false,
      activeSampleStatus3: false,
      activeSampleStatus4: false,
      username: localStorage.getItem('username'),
      password: localStorage.getItem('password'),
      loggedIn: localStorage.getItem('loggedIn'),
      associate: localStorage.getItem('associate'),
      loginError: '',
      notePublic: '',
      notePrivate: '',
      query: '',
      search_data: [],
      clientId: '-',
      clientCompany: '-',
      clientName: '-',
      traderCompany: '-',
      productData: [],
      productTableRow: {},
      productId: 0,
      productLabel: 'Infogespräch',
      productItemNumber: '-',
      productVariant: '',
      payload: [],
      finishingOptions: [],
      priceOptions: {},
      selectId: 0,
      requestId: 'new',
      updateComponent: false,
      editableColumns: [
        {
          label: 'Staffelmenge',
          field: 'quote'
        }
      ],
      editableRows: [],
      eventCategory: localStorage.getItem('eventCategory'),
      eventYear: localStorage.getItem('eventYear'),
      eventId: localStorage.getItem('event'),
      eventLabel: localStorage.getItem('eventLabel'),
      eventTotalTraders: localStorage.getItem('totalTraders'),
      eventTotalClients: localStorage.getItem('totalClients'),
      eventTotalRequests: localStorage.getItem('totalRequests'),
      eventCategoryOptions: [],
      eventYearOptions: [],
      eventLocationOptions: [],
      camera: null,
      barcodes: [],
      cameraView: null
    }
  },
  mounted () {
    if (localStorage.username) {
      this.username = localStorage.username
    }
    if (localStorage.password) {
      this.password = localStorage.password
    }
    if (localStorage.loggedIn) {
      this.loggedIn = localStorage.loggedIn
    } else {
      this.loggedIn = false
    }
    if (localStorage.associate) {
      this.associate = localStorage.associate
    }
    if (localStorage.eventCategory) {
      this.eventCategory = localStorage.eventCategory
    }
    if (localStorage.eventYear) {
      this.eventYear = localStorage.eventYear
    }
    if (localStorage.eventId) {
      this.eventId = localStorage.eventId
    }
    if (localStorage.eventLabel) {
      this.eventLabel = localStorage.eventLabel
    }
    if (localStorage.eventTotalTraders) {
      this.eventTotalTraders = localStorage.eventTotalTraders
    }
    if (localStorage.eventTotalClients) {
      this.eventTotalClients = localStorage.eventTotalClients
    }
    if (localStorage.eventTotalRequests) {
      this.eventTotalRequests = localStorage.eventTotalRequests
    }
    // this.resetQuotation()
  },
  watch: {
    username (newUsername) {
      localStorage.username = newUsername
    },
    password (newPassword) {
      localStorage.password = newPassword
    },
    loggedIn (newLoggedIn) {
      localStorage.loggedIn = newLoggedIn
    },
    associate (newAssociate) {
      localStorage.associate = newAssociate
    },
    activeTab (newTab) {
      if (newTab === 0) {
        this.getEvents()
      }
      if (newTab === 1) {
        var inputField = document.getElementById('search-client-input')
        setTimeout(function () {
          inputField.focus()
        }, 100)
        navigator.mediaDevices
          .getUserMedia({
            audio: false,
            video: {
              facingMode: 'environment'
            }
          })
          .then(stream => {
            this.cameraView = this.$refs.cameraView
            this.cameraView.srcObject = stream
            this.camera = stream
          })
          .catch(error => {
            alert(error)
          })
      }
      if (newTab === 2) {
        this.$refs.requestsTable.updateData()
      }
      if (newTab === 3) {
        this.productTableRow = {}
      }
      if (newTab === 4) {
        // if (!isObjectEmpty(this.productTableRow)) {
        //   setTimeout(function () {
        //     this.productTableRow.focus()
        //   }, 1000)
        // }
      }
    },
    eventCategory (value) {
      localStorage.eventCategory = value
    },
    eventYear (value) {
      localStorage.eventYear = value
    },
    eventId (value) {
      localStorage.eventId = value
    },
    eventLabel (value) {
      localStorage.eventLabel = value
    },
    eventTotalTraders (value) {
      localStorage.eventTotalTraders = value
    },
    eventTotalClients (value) {
      localStorage.eventTotalClients = value
    },
    eventTotalRequests (value) {
      localStorage.eventTotalRequests = value
    }
  },
  methods: {
    login () {
      axios.post('login.php', {
        username: this.username,
        password: this.password
      }).then(response => {
        if (response.data.loggedIn === true) {
          this.loginError = response.data.error
          this.loggedIn = true
          this.activeTab = 0
        } else {
          this.loginError = response.data.error
        }
      })
    },
    logout () {
      axios.get('logout.php').then(response => {
        if (response.data.loggedIn === false) {
          this.username = ''
          this.password = ''
          this.loggedIn = false
          this.associate = ''
          this.resetQuotation(true)
          this.showLogout = false
        } else {
          alert('Es ist ein Fehler aufgetreten!')
        }
      })
    },
    getEvents () {
      axios.post('select_events.php?account=' + this.username, {
        eventCategory: this.eventCategory,
        eventYear: this.eventYear,
        eventId: this.eventId
      }).then(response => {
        this.eventCategoryOptions = response.data.eventCategoryOptions
        this.eventYearOptions = response.data.eventYearOptions
        this.eventLocationOptions = response.data.eventLocationOptions
        this.eventCategory = response.data.eventCategory
        this.eventYear = response.data.eventYear
        this.eventId = response.data.eventId
        this.eventLabel = response.data.eventLabel
        this.eventTotalTraders = response.data.totalTraders
        this.eventTotalClients = response.data.totalClients
        this.eventTotalRequests = response.data.totalRequests
      })
    },
    getEventCategories (value) {
      if (value !== this.eventCategory) {
        this.eventCategory = value
        axios.post('select_events.php?account=' + this.username, {
          eventCategory: value,
          eventYear: this.eventYear,
          eventId: this.eventId
        }).then(response => {
          this.eventCategoryOptions = response.data.eventCategoryOptions
          this.eventYearOptions = response.data.eventYearOptions
          this.eventLocationOptions = response.data.eventLocationOptions
        })
      }
    },
    getEventYears (value) {
      if (value !== this.eventYear) {
        this.eventYear = value
        axios.post('select_events.php?account=' + this.username, {
          eventCategory: this.eventCategory,
          eventYear: value,
          eventId: this.eventId
        }).then(response => {
          this.eventCategoryOptions = response.data.eventCategoryOptions
          this.eventYearOptions = response.data.eventYearOptions
          this.eventLocationOptions = response.data.eventLocationOptions
        })
      }
    },
    setEventLocation (value) {
      if (value !== this.eventId) {
        this.eventId = value
        this.getEvents()
      }
    },
    addToPriceTable () {
      const newRow = {
        quote: 'Wert eingeben ...'
      }
      this.editableRows.push(newRow)
      var table = this.$refs.priceTable.$el
      var lastValue = table.querySelector('tbody tr:last-of-type td:first-of-type')
      lastValue.scrollIntoView()
      // var table = this.$refs.priceTable.$el
      // setTimeout(function () {
      //   var lastValue = table.querySelector('tbody tr:last-of-type td:first-of-type')
      //   lastValue.focus()
      //   var range = document.createRange()
      //   range.selectNodeContents(lastValue)
      //   var sel = window.getSelection()
      //   sel.removeAllRanges()
      //   sel.addRange(range)
      //   lastValue.scrollIntoView()
      // }, 100)
    },
    loadPriceTablePreset (value) {
      this.editableRows = []
      var i = 1
      if (value === 1) {
        for (const row of this.priceOptions.rows) {
          const newRow = {
            quote: row.quote
          }
          if (i <= 1) {
            this.editableRows.push(newRow)
          }
          i++
        }
      } else if (value === 2) {
        for (const row of this.priceOptions.rows) {
          const newRow = {
            quote: row.quote
          }
          if (i <= 3) {
            this.editableRows.push(newRow)
          }
          i++
        }
      } else if (value === 3) {
        for (const row of this.priceOptions.rows) {
          const newRow = {
            quote: row.quote
          }
          this.editableRows.push(newRow)
        }
      } else if (value === 4) {
        const newRow = {
          quote: 1
        }
        this.editableRows.push(newRow)
      }
    },
    translateTable () {
      var table = this.$refs.priceTable.$el
      var header = table.querySelector('thead th:last-of-type')
      header.innerHTML = ''
      var buttons = table.querySelectorAll('tbody tr td:last-of-type button')
      for (var i = 0; i < buttons.length; ++i) {
        buttons[i].style.display = 'block'
        buttons[i].innerHTML = '<i class="fas prefix fa-times"></i>'
      }
      var values = table.querySelectorAll('tbody tr td:first-of-type')
      for (i = 0; i < values.length; ++i) {
        values[i].setAttribute('inputmode', 'decimal')
        values[i].addEventListener('keydown', function (e) {
          var key = e.keyCode || e.charCode
          if (key === 13) {
            e.preventDefault()
            this.blur()
            window.getSelection().removeAllRanges()
          }
        })
        values[i].addEventListener('keyup', function (e) {
          var key = e.keyCode || e.charCode
          if (key === 9) {
            var range = document.createRange()
            range.selectNodeContents(e.target)
            var sel = window.getSelection()
            sel.removeAllRanges()
            sel.addRange(range)
          }
        })
        var htmlstring = values[i].innerHTML
        htmlstring = (htmlstring.trim) ? htmlstring.trim() : htmlstring.replace(/^\s+/, '')
        if (htmlstring === 'quote') {
          values[i].innerHTML = 'Wert eingeben ...'
        }
      }
    },
    tweakTable (event) {
      var range = document.createRange()
      range.selectNodeContents(event.target)
      var sel = window.getSelection()
      sel.removeAllRanges()
      if (event.target.nodeName === 'TD') {
        sel.addRange(range)
      }
    },
    toggleQuotationMode1 () {
      this.activeQuotationMode1 = true
      this.activeQuotationMode2 = false
      this.productId = 0
      this.productLabel = 'Infogespräch'
      this.productItemNumber = '-'
      this.productVariant = ''
      this.finishingOptions = []
      this.priceOptions = {}
    },
    toggleQuotationMode2 () {
      if (this.productId === 0) {
        this.activeQuotationMode1 = false
        this.activeQuotationMode2 = true
        this.productId = 0
        this.productLabel = 'Individuell'
        this.productItemNumber = '-'
        this.productVariant = ''
        this.activeTab = 4
        window.scrollTo(0, 0)
      }
    },
    toggleCatalogStatus1 () {
      this.activeCatalogStatus1 = true
      this.activeCatalogStatus2 = false
      this.activeCatalogStatus3 = false
    },
    toggleCatalogStatus2 () {
      this.activeCatalogStatus1 = false
      this.activeCatalogStatus2 = true
      this.activeCatalogStatus3 = false
    },
    toggleCatalogStatus3 () {
      this.activeCatalogStatus1 = false
      this.activeCatalogStatus2 = false
      this.activeCatalogStatus3 = true
    },
    toggleSampleStatus1 () {
      this.activeSampleStatus1 = true
      this.activeSampleStatus2 = false
      this.activeSampleStatus3 = false
      this.activeSampleStatus4 = false
    },
    toggleSampleStatus2 () {
      this.activeSampleStatus1 = false
      this.activeSampleStatus2 = true
      this.activeSampleStatus3 = false
      this.activeSampleStatus4 = false
    },
    toggleSampleStatus3 () {
      this.activeSampleStatus1 = false
      this.activeSampleStatus2 = false
      this.activeSampleStatus3 = true
      this.activeSampleStatus4 = false
    },
    toggleSampleStatus4 () {
      this.activeSampleStatus1 = false
      this.activeSampleStatus2 = false
      this.activeSampleStatus3 = false
      this.activeSampleStatus4 = true
    },
    searchClient: function () {
      this.search_data = []
      axios.post('search_client.php?event=' + this.eventId, {
        query: this.query
      }).then(response => {
        this.search_data = response.data
      })
    },
    getClientData: function (client) {
      this.query = client.id - 0
      this.clientId = client.id - 0
      this.clientCompany = client.company
      this.clientName = client.first_name + ' ' + client.last_name
      this.traderCompany = client.referral
      this.search_data = []
    },
    selectQuotation: function (index) {
      index++
      this.selectId = document.getElementById('requests-table').querySelector('tr:nth-child(' + index + ') div').innerHTML
    },
    selectProduct: function (index) {
      index++
      this.selectId = document.getElementById('products-table').querySelector('tr:nth-child(' + index + ') div').innerHTML
    },
    cancelProduct: function (index) {
      this.activeQuotationMode1 = true
      this.activeQuotationMode2 = false
      this.productId = 0
      this.productLabel = 'Infogespräch'
      this.productItemNumber = '-'
      this.productVariant = ''
      this.finishingOptions = []
      this.priceOptions = {}
      this.activeTab = 3
    },
    loadProduct: function () {
      this.activeQuotationMode1 = false
      this.activeQuotationMode2 = true
      this.productId = this.selectId
      if (this.productId === '-') {
        this.productId = 0
      }
      // this.productItemNumber = row.querySelector('td:nth-child(2) div').innerHTML
      // this.productVariant = row.querySelector('td:nth-child(3) div').innerHTML
      // this.productLabel = row.querySelector('td:nth-child(4) div').innerHTML
      axios.get('get_product.php?id=' + this.productId).then(response => {
        this.productItemNumber = response.data.item_number
        this.productVariant = response.data.item_variant
        this.productLabel = response.data.label
        axios.get('get_finishings.php?id=' + this.productId).then(response => {
          this.finishingOptions = response.data
          this.updateComponent = true
          axios.get('get_prices.php?id=' + this.productId).then(response => {
            this.priceOptions = response.data
            this.editableRows = [{quote: response.data.first}]
            this.updateComponent = false
            this.activeTab = 5
            window.scrollTo(0, 0)
          })
        })
      })
    },
    loadQuotation: function () {
      // this.saveQuotation(false, true)
      this.requestId = this.selectId
      axios.get('get_request.php?id=' + this.requestId).then(response => {
        this.notePrivate = response.data.supplier_note
        this.notePublic = response.data.trader_note
        this.query = response.data.client
        this.clientId = response.data.client
        this.clientCompany = response.data.client_company
        this.clientName = response.data.client_title + ' ' + response.data.client_last_name
        this.traderCompany = response.data.trader_company
        this.productId = response.data.product
        this.productLabel = response.data.product_label
        this.productItemNumber = response.data.product_item_number
        this.productVariant = response.data.product_item_variant
        this.editableRows = response.data.product_price
        this.finishingTemp = response.data.finishing
        if (response.data.client_catalog === 0) {
          this.activeCatalogStatus1 = true
          this.activeCatalogStatus2 = false
          this.activeCatalogStatus3 = false
        } else if (response.data.client_catalog === 1) {
          this.activeCatalogStatus1 = false
          this.activeCatalogStatus2 = true
          this.activeCatalogStatus3 = false
        } else if (response.data.client_catalog === 2) {
          this.activeCatalogStatus1 = false
          this.activeCatalogStatus2 = false
          this.activeCatalogStatus3 = true
        }
        if (response.data.client_sample === 0) {
          this.activeSampleStatus1 = true
          this.activeSampleStatus2 = false
          this.activeSampleStatus3 = false
          this.activeSampleStatus4 = false
        } else if (response.data.client_sample === 1) {
          this.activeSampleStatus1 = false
          this.activeSampleStatus2 = false
          this.activeSampleStatus3 = true
          this.activeSampleStatus4 = false
        } else if (response.data.client_sample === 2) {
          this.activeSampleStatus1 = false
          this.activeSampleStatus2 = false
          this.activeSampleStatus3 = false
          this.activeSampleStatus4 = true
        } else if (response.data.client_sample === 3) {
          this.activeSampleStatus1 = false
          this.activeSampleStatus2 = true
          this.activeSampleStatus3 = false
          this.activeSampleStatus4 = false
        }
        if (response.data.client_consultation === 0) {
          this.activeQuotationMode1 = false
          this.activeQuotationMode2 = true
        } else if (response.data.client_consultation === 1) {
          this.activeQuotationMode1 = true
          this.activeQuotationMode2 = false
        }
        axios.get('get_finishings.php?id=' + this.productId).then(response => {
          this.finishingOptions = response.data
          this.updateComponent = true
          for (let i = 0; i < this.finishingTemp.length; i++) {
            for (let j = 0; j < this.finishingOptions.length; j++) {
              if (this.finishingOptions[j].value === this.finishingTemp[i]) {
                this.finishingOptions[j].selected = true
              }
            }
          }
          axios.get('get_prices.php?id=' + this.productId).then(response => {
            this.priceOptions = response.data
            // this.editableRows = [{quote: response.data.first}]
            this.updateComponent = false
          })
        })
        if (this.productId !== '' || this.productLabel === 'Sonderanfertigung') {
          this.activeTab = 5
        } else {
          this.activeTab = 3
        }
        window.scrollTo(0, 0)

        this.flashMessage.show({
          status: 'success',
          time: 1500,
          title: 'Laden erfolgreich',
          message: 'Die gewählte Anfrage wurde geladen.',
          y: 400,
          blockClass: 'gww-flash-message'
        })
      })
    },
    resetQuotation: function (option) {
      this.notePublic = ''
      this.notePrivate = ''
      this.noteTab = 0
      this.productId = 0
      this.productLabel = 'Infogespräch'
      this.productItemNumber = '-'
      this.productVariant = ''
      this.finishingOptions = []
      this.priceOptions = {}
      this.selectId = 0
      this.requestId = 'new'
      this.activeQuotationMode1 = true
      this.activeQuotationMode2 = false
      this.activeSampleStatus1 = true
      this.activeSampleStatus2 = false
      this.activeSampleStatus3 = false
      this.activeSampleStatus4 = false
      this.showDelete = false
      if (option === true) {
        this.query = ''
        this.search_data = []
        this.clientId = '-'
        this.clientCompany = '-'
        this.clientName = '-'
        this.traderCompany = '-'
        this.activeCatalogStatus1 = true
        this.activeCatalogStatus2 = false
        this.activeCatalogStatus3 = false
        this.activeTab = 0
      } else {
        this.activeTab = 3
      }
      window.scrollTo(0, 0)
    },
    saveQuotation: function (reset, option) {
      if (this.clientId === 0 || this.clientId === '-' || this.clientId === '') {
        if (this.requestId === 'new' && this.selectId === 0) {
          alert('Es wurde kein Kunde ausgewählt!')
        }
      } else {
        this.payload['request_id'] = this.requestId
        this.payload['quantity'] = ''
        if (this.$refs.priceTable) {
          for (let i = 0; i < this.$refs.priceTable._data.mutableRows.length; i++) {
            if (!isNaN(this.$refs.priceTable._data.mutableRows[i].quote)) {
              this.payload['quantity'] += this.$refs.priceTable._data.mutableRows[i].quote + '|'
            }
          }
          this.payload['quantity'] = this.payload['quantity'].substring(0, this.payload['quantity'].length - 1)
        }
        if (this.productLabel !== 'Infogespräch' && this.payload['quantity'] === '') {
          alert('Es wurde keine gültigen Staffelmengen angegeben!')
        } else {
          this.payload['created'] = new Date().toISOString().slice(0, 19).replace('T', ' ')
          this.payload['associate'] = this.associate
          this.payload['client'] = this.clientId
          this.payload['product'] = this.productId
          this.payload['finishing'] = ''
          for (let i = 0; i < this.finishingOptions.length; i++) {
            if (this.finishingOptions[i].selected === true) {
              this.payload['finishing'] += this.finishingOptions[i].value + '|'
            }
          }
          this.payload['finishing'] = this.payload['finishing'].substring(0, this.payload['finishing'].length - 1)
          if (this.activeCatalogStatus1 === true) {
            this.payload['catalog'] = 0
          }
          if (this.activeCatalogStatus2 === true) {
            this.payload['catalog'] = 1
          }
          if (this.activeCatalogStatus3 === true) {
            this.payload['catalog'] = 2
          }
          if (this.activeSampleStatus1 === true) {
            this.payload['sample'] = 0
          }
          if (this.activeSampleStatus2 === true) {
            this.payload['sample'] = 3
          }
          if (this.activeSampleStatus3 === true) {
            this.payload['sample'] = 1
          }
          if (this.activeSampleStatus4 === true) {
            this.payload['sample'] = 2
          }
          if (this.productLabel === 'Infogespräch') {
            this.payload['consultation'] = 1
          } else {
            this.payload['consultation'] = 0
          }
          this.payload['notePublic'] = this.notePublic
          this.payload['notePrivate'] = this.notePrivate
          axios({
            method: 'post',
            url: 'report.php?user=' + this.username + '&key=' + this.password,
            data: {
              request_id: this.payload['request_id'],
              created: this.payload['created'],
              associate: this.payload['associate'],
              client: this.payload['client'],
              product: this.payload['product'],
              finishing: this.payload['finishing'],
              quantity: this.payload['quantity'],
              catalog: this.payload['catalog'],
              sample: this.payload['sample'],
              consultation: this.payload['consultation'],
              note_public: this.payload['notePublic'],
              note_private: this.payload['notePrivate']
            }
          }).then(response => {
            if (response.data.success === false) {
              alert(response.data.error)
            } else {
              if (reset === true) {
                this.resetQuotation(option)
              }
              this.showSave = false
              // if (this.requestId === 'new' && this.selectId === 0) {
              this.flashMessage.show({
                status: 'success',
                time: 1500,
                title: 'Speichern erfolgreich',
                message: 'Ihre Anfrage wurde erfolgreich gespeichert.',
                y: 400,
                blockClass: 'gww-flash-message'
              })
              // }
            }
          }).catch(error => {
            alert('Die Verbindung konnte nicht hergestellt werden oder wurde unterbrochen. Bitte versuchen Sie es später erneut (' + error.message + ')')
          })
        }
      }
    },
    onDecode (result) {
      if (typeof result[0].rawValue !== 'undefined') {
        var barcode = parseInt(result[0].rawValue)
        this.search_data = []
        axios.post('search_client.php?event=' + this.eventId, {
          query: barcode
        }).then(response => {
          this.search_data = response.data
          this.getClientData(response.data[0])
          this.toggleCamera = false
        })
      }
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .client-search {
    z-index: 9999 !important;
  }
  main {
    padding-left: 0px !important;
  }
  .gww-bottom-margin {
    margin-bottom: 0px !important;
    padding-bottom: 87px !important;
  }
  .select-dropdown .btn-save {
    height: 40px !important;
    font-size: 17px !important;
  }
  .gwwPriceTable th {
    color: #888 !important;
  }
  .gwwPriceTable td {
    color: #777 !important;
  }
  .gww-flash-message {
    background-color: #007E33 !important;
    margin-bottom: 92px !important;
    padding: 10px !important;
    z-index: 9999 !important;
  }
  .gww-flash-message ._vue-flash-msg-body__content {
    border: none !important;
  }
  ul.select-dropdown {
    max-height: 300px !important;
  }
  .modal-bottom-right {
    margin: 0px !important;
    padding-left: 10px !important;
    max-width: 100% !important;
    position: absolute !important;
    bottom: 10px !important;
    right: 10px !important;
  }
  .dataTable {
    min-width: 300px !important;
  }
  .dataTables_filter input {
    width: 100% !important;
    margin-bottom: 15px !important;
    padding: 10px !important;
    border: 1px solid #ccc !important;
  }
  .dataTable thead {
    display: none !important;
  }
  .dataTable td {
    font-size: 16px !important;
    color: #0068b4 !important;
  }
  .dataTable small {
    color: #444 !important;
    display: block !important;
  }
  .dataTable b {
    font-weight: 500 !important;
  }
  #products-table td {
    font-weight: 500 !important;
  }
  .price-data .table-add {
    float: left !important;
    margin-bottom: 0px !important;
  }
  .price-data td {
    border: none !important;
    padding: 0px !important;
    padding-bottom: 3px !important;
    padding-top: 3px !important;
  }
  .price-data tbody tr td:first-child {
    vertical-align: middle !important;
    font-size: 21px !important;
    font-weight: bold !important;
    line-height: 40px !important;
    padding-left: 9px !important;
  }
  .price-data .table-remove {
    background-color: #d32f2f !important;
    font-size: 20px !important;
    line-height: 20px !important;
    padding: 14px !important;
    padding-left: 17px !important;
    padding-right: 17px !important;
    float: right !important;
  }
  .price-data .table-add {
    display: none !important;
  }
  .barcode-scanner, ul {
    width: 100%;
    margin-left: auto;
    margin-right: auto;
  }
  .mask {
    left: 20%;
    right: 20%;
    top: 30%;
    bottom: 30%;
    box-shadow: 0 0 0 10000px rgba(0, 0, 0, 0.4);
  }
  .cameraView {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 50%;
  }
</style>



// WEBPACK FOOTER //
// src/components/quotation/Quotation.vue